import { render, staticRenderFns } from "./PromotionStat.vue?vue&type=template&id=3d52f910&scoped=true&"
import script from "./PromotionStat.vue?vue&type=script&lang=js&"
export * from "./PromotionStat.vue?vue&type=script&lang=js&"
import style0 from "./PromotionStat.vue?vue&type=style&index=0&id=3d52f910&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d52f910",
  null
  
)

export default component.exports